/**
 * TODO: https://1stdibs.atlassian.net/browse/MW-127
 */
export default function ErrorComponent() {
    return null;
}
